import { VStack } from '@chakra-ui/react'

export const FilterStack = ({ children, ...props }) => {
  return (
    <VStack
      gap={5}
      pt="26px"
      pr="26px"
      pl="26px"
      width="100%"
      pb="30px"
      alignItems="inherit"
      {...props}
    >
      {children}
    </VStack>
  )
}
